import { render, staticRenderFns } from "./PositionEdit.vue?vue&type=template&id=18dc051c"
import script from "./PositionEdit.vue?vue&type=script&lang=js"
export * from "./PositionEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports